import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { ComponentPropsWithoutRef } from "react";

import { t } from "@/i18n-js/instance";
import {
  anchorClassNames,
  legacyClassNames,
} from "@/react/helpers/cssAnchorHelpers";

import { RailbarContainer } from "./RailbarContainer";

export interface ContentProps extends ComponentPropsWithoutRef<"div"> {
  disableSidebar?: boolean;
  fullHeight?: boolean;
  fullWidth?: boolean;
  noPadding?: boolean;
}

export const Content = ({
  children,
  fullWidth,
  fullHeight = true,
  noPadding,
  ...props
}: ContentProps) => (
  <main
    aria-label={t("main_content")}
    {...props}
    className={classNames(
      anchorClassNames("standard-layout-v2__content", {
        "standard-layout-v2__content--full": fullWidth,
      }),
      "lg:bg-secondary",
      noPadding && legacyClassNames("standard-layout-v2__content--no-padding"),
      {
        "h-full min-h-full": fullHeight,
      },
    )}
  >
    <div
      className={classNames(
        "lg:bg-secondary",
        fullHeight && "h-full min-h-full",
      )}
    >
      {children}
    </div>
    <RailbarContainer id="rail-bar-content" />
  </main>
);
